import {
  Component,
  ElementRef,
  OnInit,
  signal,
  viewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { Credentials } from "../../models/credentials.model";
import { AuthService } from "../../services/auth.service";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { SharedModule } from "../../../../shared/shared.module";
import { LogoComponent } from "../../../../shared/components/logo/logo.component";
import { DividerComponent } from "../../../../shared/components/divider/divider.component";
import { BigButtonComponent } from "../../../../shared/components/big-button/big-button.component";

@Component({
  selector: "vl-login-dialog",
  imports: [SharedModule, LogoComponent, DividerComponent, BigButtonComponent],
  standalone: true,
  templateUrl: "./login-dialog.component.html",
  styleUrls: ["./login-dialog.component.scss"],
})
export class LoginDialogComponent implements OnInit {
  formGroup: FormGroup;
  subs: Subscription[] = [];
  loading = signal(false);
  pwdInput = viewChild<ElementRef>("pwd");

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    private localStorageService: LocalStorageService,
  ) {
    const lastUser = this.localStorageService.getWithTTL("lastUserMail");
    this.formGroup = this.formBuilder.group({
      username: [lastUser, Validators.required],
      password: [null, Validators.required],
    });
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.authService.popupOpened = true;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.formGroup.get("username").value) {
        this.pwdInput?.()?.nativeElement.focus();
        this.pwdInput?.()?.nativeElement.select();
      }
    }, 100);
  }

  async onLogin() {
    if (this.formGroup.valid) {
      try {
        this.loading.set(true);
        await this.authService.login({
          username: this.formGroup.get("username").value,
          password: this.formGroup.get("password").value,
        } as Credentials);
        this.dialogRef.close();
      } finally {
        this.loading.set(false);
      }
    }
  }

  ngOnDestroy() {
    this.authService.popupOpened = false;
    this.subs.forEach((s) => s.unsubscribe());
  }
}
